import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import { FiPlus } from "react-icons/fi";
import { FaMinus } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";

function FAQList() {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Stack
      sx={{
        // border: "1px solid blue",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Roboto', sans-serif",
        paddingBottom: {
          xl: "60px",
          lg: "40px",
          md: "0px",
          sm: "0px",
          xs: "32px",
        },
        backgroundColor: "rgb(218 233 248)",
        // gap: 2,
      }}
    >
      <Stack
        sx={{
          //border: "1px solid red",
          width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
          display: "flex",
          flexDirection: "column",
          marginBottom: { xl: "0px", lg: "0px", md: "30px" }
        }}
      >
        <Stack
          sx={{
            // border: {xl: "1px solid red", lg: "1px solid green", md: "1px solid blue", sm: "1px solid gray", xs: "1px solid yellow", },
            fontFamily: "'Roboto', sans-serif",
            fontSize: {
              xs: "20px",
              sm: "30px",
              md: "28px",
              lg: "40px",
              xl: "40px",
            },
            lineHeight: {
              xs: "28px",
              sm: "36px",
              md: "32px",
              lg: "52px",
              xl: "52px",
            },
            fontWeight: 600,
            color: "rgb(5 78 146)",
            textAlign: "center",
            marginBottom: {
              xs: "20px",
              sm: "20px",
              md: "20px",
              lg: "20px",
              xl: "20px",
            },
            marginTop: {
              xs: "20px",
              sm: "20px",
              md: "40px",
              lg: "64px",
              xl: "64px",
            },
            // border: "1px solid red",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Stack
            sx={{
              // border: "1px solid red",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Stack
              sx={{
                width: { xl: "6px", lg: "6px", xs: "4px" },
                height: {
                  xs: "20px",
                  sm: "44px",
                  md: "28px",
                  lg: "40px",
                  xl: "36px",
                },
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                border: "1px solid rgb(5 78 146)",
                backgroundColor: "rgb(5 78 146)",
                marginRight: {
                  xs: "8px",
                  sm: "8px",
                  md: "12px",
                  lg: "12px",
                  xl: "12px",
                },
                borderTopRightRadius: "8px", // Adjust the value as needed
                borderBottomRightRadius: "8px", // Adjust the value as needed
              }}
            >
              <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
            </Stack>
          </Stack>
          <span style={{ display: "inline-flex", alignItems: "center" }}>
            Frequently ask questions
          </span>
        </Stack>

        <Stack
          sx={{
            display: { sm: "flex", xs: "none" },
            width: "100%",
            fontFamily: "'Roboto', sans-serif",
            fontSize: {
              xs: "16px",
              sm: "16px",
              md: "16px",
              lg: "22px",
              xl: "22px",
            },
            lineHeight: {
              xs: "24px",
              sm: "28px",
              md: "32px",
              lg: "32px",
              xl: "32px",
            },
            fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
            color: "#333",
            border: "1px solid white",
            textAlign: "left",
            // border: "1px solid rgb(218 233 248)",
            padding: 1,
            borderRadius: "8px",
            backgroundColor: "white",
            marginBottom: {
              xs: "20px",
              sm: "20px",
              md: "20px",
              lg: "64px",
              xl: "64px",
            },
          }}
        >
          <span>
             {" "}

            <span style={{ fontWeight: 600 }}>
            </span>{" "}
            Every business is unique-and so are your pricing questions. Our FAQ section dives deep into everything you need to know about Vertex Suite plans, add-ons, integrations and usage terms. Whether you are scaling up or just starting out, this section helps you make informed decisions with full transparency-no hidden charges, no confusion. Because automation should be simple, not complicated.
          </span>
        </Stack>

        <Stack
          sx={{
            display: { sm: "none", xs: "flex" },
            width: "100%",
            fontFamily: "'Roboto', sans-serif",
            fontSize: {
              xs: "16px",
              sm: "16px",
              md: "16px",
              lg: "24px",
              xl: "24px",
            },
            lineHeight: {
              xs: "24px",
              sm: "28px",
              md: "32px",
              lg: "32px",
              xl: "32px",
            },
            fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
            color: "#333",
            border: "1px solid white",
            textAlign: "left",
            // border: "1px solid rgb(218 233 248)",
            padding: 1,
            borderRadius: "8px",
            backgroundColor: "white",
            marginBottom: {
              xs: "20px",
              sm: "20px",
              md: "20px",
              lg: "64px",
              xl: "64px",
            },
          }}
        >
          <span>
            Find everything you need to know to start and succeed with the {" "}
            <span style={{ fontWeight: 600 }}>
              <span style={{ color: "#054E91" }}>Vertex</span>{" "}
              <span style={{ color: "#53AFE4" }}>Suite</span>
            </span>{" "}
            platform.
          </span>
        </Stack>
      </Stack>
      <Stack
        sx={{
          // border: "1px solid red",
          width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },

          //glassmorphic ui
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          backdropFilter: "blur(12px)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          // border: "1px solid rgba(255, 255, 255, 0.2)",
          // border: "1px solid red",
          transition: "all 0.5s ease-in-out",
          fontFamily: "'Roboto', sans-serif",
          marginBottom: { xl: "24px", lg: "0px", md: "56px" },
          //for shine
        }}
      >
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleToggle("panel1")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel1" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel1" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              What does Unlimited Users mean?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "24px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Unlimited Users means there's no cap on Monthly Active Users
              (MAUs) you can connect with. Whether it's 1,000 or 1 million
              users, connect without restrictions! You'll only pay for WhatsApp
              Conversation Charges.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleToggle("panel2")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel2" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel2" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Are WhatsApp Conversations charged separately?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "24px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Yes, WhatsApp Conversations are charged based on the type of
              conversation (Marketing, Utility, or Authentication). The charges
              are deducted from pre-purchased Conversation Credits.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleToggle("panel3")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel3" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel3" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              What is the Customer Service Window/Session Window?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "24px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              A 24-hour Messaging Session begins when a customer sends a message
              to your WhatsApp Business number. During this time, you can send
              unlimited responses without additional charges.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleToggle("panel4")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel4" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel4" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel4a-content"
            id="panel4a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Is the billing system pre-paid or post-paid?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "25px",
                marginBottom: "8px", // Add spacing below the heading
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              All Vertex Suite billings operate on a pre-paid basis to give you
              full control over your usage and spending.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel5"}
          onChange={handleToggle("panel5")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel5" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel5" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel5a-content"
            id="panel5a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              How many contacts can I import to Vertex Suite?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "24px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              You can import unlimited contacts into Vertex Suite. Charges apply
              only when you initiate a conversation with a user.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel6"}
          onChange={handleToggle("panel6")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel6" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel6" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel6a-content"
            id="panel6a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              How does the upgrade or downgrade system work?
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "24px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Upgrades or downgrades are adjusted on a pro-rata basis, ensuring
              you only pay for the services you use.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel7"}
          onChange={handleToggle("panel7")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel7" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel7" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel7a-content"
            id="panel7a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Are there additional charges for WhatsApp templates?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "24px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Pre-approved WhatsApp templates may incur additional charges
              depending on the type of conversation initiated using the
              template.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel8"}
          onChange={handleToggle("panel8")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel8" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel8" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel8a-content"
            id="panel8a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Do prices vary based on customer location?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "25px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Yes, WhatsApp Conversation Charges vary by region. Indian users,
              for example, pay ₹0.88 for Marketing Conversations, while prices
              differ for international users.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel9"}
          onChange={handleToggle("panel9")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel9" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel9" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel9a-content"
            id="panel9a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              What are Conversation Credits, and how are they managed?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "24px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Conversation Credits are prepaid balances used to pay for WhatsApp
              conversations. They can be recharged and managed easily via the
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel10"}
          onChange={handleToggle("panel10")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel10" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel10" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel10a-content"
            id="panel10a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Is there a limit on the number of messages I can send?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "24px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              There's no limit on the number of messages sent within a
              conversation window. Outside this, charges apply based on the
              conversation type.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel10"}
          onChange={handleToggle("panel10")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel10" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel10" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel10a-content"
            id="panel10a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Does Vertex Suite provide any free conversations?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "24px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              WhatsApp typically offers 1,000 free conversations per month for
              businesses, depending on your eligibility. Beyond this, standard
              charges apply.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel10"}
          onChange={handleToggle("panel10")}
          sx={{
            "&:hover": {
              backgroundColor: "#f4f4ff",
            },
            backgroundColor: expanded === "panel10" ? "#f4f4ff" : "none",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel10" ? (
                <FaMinus style={{ fontSize: "20px", color: "#5858e0" }} />
              ) : (
                <FaPlus style={{ fontSize: "20px", color: "#5858e0" }} />
              )
            }
            aria-controls="panel10a-content"
            id="panel10a-header"
          >
            <Typography
              sx={{
                fontSize: { xl: "20px", lg: "20px", sm: "20px", xs: "16px" },
                fontWeight: 500,
                color: "#333",
                lineHeight: "26px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              How are payments processed for Conversation Credits?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#373838",
                lineHeight: "24px",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Payments are processed via multiple methods, including Razorpay,
              Paytm, and UPI, ensuring convenience and security.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Stack>
    </Stack>
  );
}

export default FAQList;
